const ACTION_TYPE = "ALERTS";
export const CREATE = `${ACTION_TYPE}/CREATE`;
export const REMOVE = `${ACTION_TYPE}/REMOVE`;
